import React from "react";
import UserAvatar from "../../common/UserAvatar/UserAvatar";
import "./CaptainDetailModal.css";

// Phase I. Detail view shown when a user taps a captain circle in
// the story strip. Read-only — admins edit captains via the dedicated
// admin tab. Only renders fields the captain row carries, so a
// placeholder captain with just name + photo still looks clean.

const formatDate = (raw) => {
  if (!raw) return null;
  // Accept both YYYY-MM-DD-... event-id-style strings and ISO dates.
  const datePart = raw.slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!m) return raw;
  const d = new Date(`${datePart}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return raw;
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const CaptainDetailModal = ({ captain, onClose }) => {
  if (!captain) return null;
  const recent = captain.recentlyHostedEvents || [];

  return (
    <div
      className="captain-modal__backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="captain-modal__panel"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="captain-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        <div className="captain-modal__hero">
          <UserAvatar
            name={captain.displayName}
            imgKey={captain.profileImgKey}
            size={120}
          />
          <h2 className="captain-modal__name">{captain.displayName}</h2>
          {captain.joinDate && (
            <div className="captain-modal__meta">
              Joined {captain.joinDate}
            </div>
          )}
        </div>

        {captain.bio && (
          <p className="captain-modal__bio">{captain.bio}</p>
        )}

        <div className="captain-modal__stats">
          <div className="captain-modal__stat">
            <div className="captain-modal__stat-value">
              {captain.eventsHostedCount}
            </div>
            <div className="captain-modal__stat-label">
              event{captain.eventsHostedCount === 1 ? "" : "s"} hosted
            </div>
          </div>
        </div>

        <div className="captain-modal__section">
          <h3 className="captain-modal__section-title">Recently hosted</h3>
          {recent.length === 0 ? (
            <p className="captain-modal__muted">
              No host history yet — events get attributed as we tag hosts
              going forward.
            </p>
          ) : (
            <ul className="captain-modal__events">
              {recent.map((e) => (
                <li key={e.id} className="captain-modal__event">
                  <div className="captain-modal__event-date">
                    {formatDate(e.date || e.id)}
                  </div>
                  <div className="captain-modal__event-title">
                    {e.title || "(untitled event)"}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaptainDetailModal;
